export const sessionData = [
  {
    id: 1,
    title: '',
    dates: 'June 9 - July 18',
    time: 'Tue/Thu, 6–8 PM PST'
  }
  // {
  //   id: 2,
  //   title: 'Session 2',
  //   dates: 'July 7 - August 15',
  //   time: 'Tue/Thu, 6–8 PM PST'
  // }
]; 